const infoPoints = [
  [
    { text: 'Set ' },
    { text: 'special commission rules', strong: true },
    { text: ' for specific campaigns (overrides entity default).' },
  ],
  [
    { text: 'Select entity, choose campaigns, and set commission as ' },
    { text: '%', strong: true },
    { text: ' or ' },
    { text: 'fixed AED', strong: true },
    { text: '.' },
  ],
  [
    { text: 'One rule per campaign; ' },
    { text: 'no duplicates allowed', strong: true },
    { text: '.' },
  ],
  [
    { text: 'If no campaigns are linked to an entity, a ' },
    { text: 'warning', strong: true },
    { text: ' appears.' },
  ],
  [
    { text: 'Saving overrides the entity commission for ' },
    { text: 'those campaigns only', strong: true },
    { text: '.' },
  ],
];

export default infoPoints;
